import React from "react";
import PropTypes from 'prop-types';
import ImageLoad from 'components/ImageLoad';
import notImage from 'images/foto_en_preparacion.png';
import Slider from "components/Slider";
import Link from 'components/Link';
import CMSFactory from "factories/CMS";
import TagManagerService from 'services/TagManager';
import style from './style.scss'; //NOSONAR

const SliderBannerOffers = (props) => {
    let serverDate = (props && props.date) ? props.date : new Date().getTime();
    let secondaryBanner = props.item ? props.item.secondaryBanner : 0;

    const getBanners = (banner, title) => {
        if(!banner) return [];
        if(!title) return '';
        let countItem = 0;

        let ban = banner.map((_item, i) => {
            let startDate = _item.start_date ? CMSFactory.milliseconds(_item.start_date) : '';
            let endDate = _item.end_date ? CMSFactory.milliseconds(_item.end_date) : '';
            if (startDate && (startDate >= serverDate)) return false;
            if (endDate && (serverDate >= endDate)) return false;

            const imageResponsive = {
                839: _item.image_mobile ? _item.image_mobile.url : '',
                1440: _item.imagen ? _item.imagen.url : ''
            };

            if (!_item.active) return false;
            if (typeof window !== 'undefined' && window.innerWidth <= 768) {
                _item.id = (_item.image_mobile && _item.image_mobile.url) ? _item.image_mobile.url.split('/').pop() : '';
            } else {
                _item.id = (_item.imagen &&  _item.imagen.url) ? _item.imagen.url.split('/').pop() : '';
            }
            countItem++;

            _item.typePromotion = 'Banner secundario '+ secondaryBanner + '- ' + title;
            _item.url_banner = _item.url;

            let position = 'slot' + (countItem);

            const gtmData = {
                id: _item.id,
                name: _item.title ? _item.title : _item.id,
                creative: _item.typePromotion,
                position: position,
                type: 'offerBanner'
            }

            return <Link key={i} to={_item.url} target={_item.url_target || _item.urlTarget} className="slider-banner-offers-content-image" onClick={() => tagPromotionsClick(_item, position, _item.typePromotion)} aria-label={_item.title}>
                {_item.imagen &&  <ImageLoad srcSet={imageResponsive} src={_item.imagen.url} alt={_item.title} gtmData={gtmData}/>}
                {!_item.imagen && <img src={notImage} />}
                {_item.title && <h2 className="slider-banner-offers-item-title">{_item.title}</h2>}
                {_item.subtitle && <h3 className="slider-banner-offers-item-subtitle">{_item.subtitle}</h3>}
            </Link>
        }).filter(Boolean);

        return ban;
    };

    const tagPromotionsClick = (itemTag, position, creative) => {
        itemTag.url_banner = itemTag.url;
        TagManagerService.promotionsClick(itemTag, position, creative);
    };

    const offers = props.item && props.item.banner_offer ? props.item.banner_offer : [];
    const titleBanner = props &&  props.item.title ? props.item.title : '';
    const item = getBanners(offers,titleBanner);

    return (
        <section className="slider-banner-offers">
            <h1 className="slider-banner-offers-title">{titleBanner}</h1>
            <div className="slider-banner-offers-wrap">
                <Slider arrows={true} className="slider-banner-offers-content">
                    {item}
                </Slider>
            </div>
        </section>
    )
}

SliderBannerOffers.propTypes = {
    item: PropTypes.object,
    date: PropTypes.number,
    secondaryBanner: PropTypes.number
};



export default SliderBannerOffers;
